<template>
    <div class="role-page full-height">
        <table-con>
            <div slot="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>配置中心</el-breadcrumb-item>
                    <el-breadcrumb-item>配置国际运费</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div slot="search">
                <el-row class="search-row">
                    <el-col :span="24" class="display-row">
                        <p style="line-height: 30px;min-width: 230px;">{{ $route.query.name }}国际运费</p>
                        <div style="text-align: right; width: 81%; padding-right: 10px">
                            <el-button class="search-btn btn-blue" @click="addConfig">新增</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div slot="table" class="full-height display-col">
                <el-form :rules="rules" label-width="80px">
                    <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle"
                        :data="configList" height="550">
                        <el-table-column align="center" type="weight" label="重量" min-width="200">
                            <template slot-scope="scope">
                                <div>
                                    <span><el-input type="number" v-model="scope.row.startWeight"
                                            style='width:80px;margin-right: 15px' disabled
                                            prop="startWeight"></el-input>&lt;a</span>
                                    <span v-if="scope.row.sortFlag != 99">≤ <el-input type="number"
                                            v-model='scope.row.endWeight' style='width:80px ;margin-left: 15px'
                                            @input='monitor(scope.row)' @blur="SubmitSave"/></span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="chargingMethod" label="收费方式" min-width="400">
                            <template slot-scope="scope">
                                <div>
                                    <div v-if='scope.row.type == 1'>
                                        固定值：<el-input type="number"
                                            @blur="(e) => validateMinValue(e, scope.row, 'firstPrice')"
                                            v-model='scope.row.firstPrice' style='width:60px' size="small" />元
                                        &nbsp;&nbsp;
                                        <span style="font-weight: 700;color: black;">实际：</span><el-input type="number"
                                            @blur="(e) => validateMinValue(e, scope.row, 'actualFirstPrice')"
                                            v-model='scope.row.actualFirstPrice' style='width:60px' size="small" />元
                                    </div>
                                    <div v-if='scope.row.type == 2'>
                                        首重：<el-input type="number" v-model='scope.row.firstWeight' style='width:60px'
                                            size="small" @blur="(e) => validateMinValue(e, scope.row, 'firstWeight')"/> kg &nbsp;&nbsp;
                                        首重价格：<el-input type="number" v-model='scope.row.firstPrice' style='width:60px'
                                            size="small" @blur="(e) => validateMinValue(e, scope.row, 'firstPrice')"/> 元 &nbsp;&nbsp;
                                        超过的单价：<el-input type="number" v-model='scope.row.excessPrice' style='width:60px'
                                            size="small" @blur="(e) => validateMinValue(e, scope.row, 'excessPrice')"/> 元/
                                        <el-input type="number" v-model='scope.row.excessWeight' style='width:60px'
                                            size="small" @blur="kgblur(scope.row, 0)" /> kg
                                        <div style="margin-top: 5px;">
                                            <div
                                                style="display: inline-block;width: 132px;text-align: right;font-weight: 700;color: black;">
                                                实际: </div>
                                            首重价格：<el-input type="number" v-model='scope.row.actualFirstPrice'
                                                style='width:60px' size="small" @blur="(e) => validateMinValue(e, scope.row, 'actualFirstPrice')"/> 元 &nbsp;&nbsp;
                                            超过的单价：<el-input type="number" v-model='scope.row.actualExcessPrice'
                                                style='width:60px' size="small" @blur="(e) => validateMinValue(e, scope.row, 'actualExcessPrice')"/> 元/
                                            <el-input disabled type="number" v-model='scope.row.excessWeight'
                                                style='width:60px' size="small" /> kg
                                        </div>
                                    </div>
                                </div>
                                <div v-if='scope.row.type == 3'>
                                    单价：<el-input type="number" v-model='scope.row.firstPrice' style='width:60px'
                                        size="small" @blur="(e) => validateMinValue(e, scope.row, 'firstPrice')"/> 元 &nbsp;&nbsp;
                                    <span style="font-weight: 700;color: black;">实际：</span><el-input type="number"
                                        v-model='scope.row.actualFirstPrice' style='width:60px' size="small" @blur="(e) => validateMinValue(e, scope.row, 'actualFirstPrice')"/>元
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column align="center" label="操作" min-width="180">
                            <template slot-scope="scope">
                                <el-button class="list-btn btn-deepblue" @click="editConfig(scope.row)">编辑</el-button>
                                <div v-if="scope.row.sortFlag != 1 && scope.row.sortFlag != 99">
                                    <el-button class="list-btn btn-warn" @click="delConfig(scope.row)">删除</el-button>
                                </div>

                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="text-align:center;margin-top: 5px;">
                        <el-button style="margin-right: 20px !important;" class="form-btn btn-green"
                            @click="goto">返回</el-button>
                        <el-button class="form-btn btn-blue" @click="SubmitSave">提交</el-button>
                    </div>
                </el-form>

            </div>
        </table-con>
        <el-dialog title="收费方式" :visible.sync="dialogVisible" width="50%" @close="ConfigDialogClose">
            <el-form :model="editFrom" label-width="120px" class="add-role-form" ref="editFrom">
                <el-form-item label="配置方式：">
                    <el-radio-group v-model="editFrom.type">
                        <el-radio label="1">固定总值</el-radio>
                        <el-radio label="2">区间值（首重)</el-radio>
                        <el-radio label="3">单价</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="editFrom.type == 1" style="display: flex;align-items: center;justify-content: flex-start;">
                    <el-form-item label="固定值：">
                        <el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'firstPrice')" v-model="editFrom.firstPrice" size="small" style="width: 100px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="实际：" class="actual-price-label">
                        <el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'actualFirstPrice')" v-model="editFrom.actualFirstPrice" size="small" style="width: 100px"></el-input> 元
                    </el-form-item>
                </div>
                <div v-if="editFrom.type == 2">
                    <el-form-item>
                        首重：<el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'firstWeight')" v-model='editFrom.firstWeight' style='width:60px ' /> kg &nbsp;&nbsp;
                        首重价格：<el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'firstPrice')" v-model='editFrom.firstPrice' style='width:60px ' /> 元 &nbsp;&nbsp;
                        超过的单价：<el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'excessPrice')" v-model='editFrom.excessPrice' style='width:60px ' /> 元/
                        <el-input type="number" v-model='editFrom.excessWeight' style='width:60px'
                            @blur="kgblur(editFrom.excessWeight, 1)" /> kg
                    </el-form-item>
                    <el-form-item>
                        <div
                            style="display: inline-block;width: 132px;text-align: right;font-weight: 700;color: black;">
                            实际:
                        </div>
                        首重价格：<el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'actualFirstPrice')" v-model='editFrom.actualFirstPrice' style='width:60px ' /> 元
                        &nbsp;&nbsp;
                        超过的单价：<el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'actualExcessPrice')" v-model='editFrom.actualExcessPrice' style='width:60px ' /> 元/
                        <el-input disabled type="number" v-model='editFrom.excessWeight' style='width:60px' /> kg
                    </el-form-item>
                </div>
                <div v-if="editFrom.type == 3" style="display: flex;align-items: center;justify-content: flex-start;">
                    <el-form-item label="单价：">
                        <el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'firstPrice')" v-model="editFrom.firstPrice" size="small" style="width: 100px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="实际：" class="actual-price-label">
                        <el-input type="number" @blur="(e) => validateMinValue(e, editFrom, 'actualFirstPrice')" v-model="editFrom.actualFirstPrice" size="small" style="width: 100px"></el-input> 元
                    </el-form-item>
                </div>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="form-btn btn-gray" @click="closeAccessoriesDialog">取 消</el-button>
                <el-button class="form-btn btn-blue" @click="confirmEdit">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 新增配置 -->
        <el-dialog title="收费方式" :visible.sync="dialogVisibleAdd" width="50%" @close="ConfigAddClose">
            <el-form :model="addFrom" label-width="120px" class="add-role-form" ref="addFrom">
                <el-form-item label="">
                    <span><el-input type="number" v-model="addFrom.startWeight" style='width:80px;margin-right: 15px'
                            :disabled="configList.length > 1" prop="startWeight"></el-input>&lt;a</span>
                    <span v-if="configList.length != 0">≤ <el-input type="number" v-model='addFrom.endWeight'
                            style='width:80px ;margin-left: 15px' @blur="blur" /></span>
                </el-form-item>
                <el-form-item label="配置方式：">
                    <el-radio-group v-model="addFrom.type">
                        <el-radio label="1">固定总值</el-radio>
                        <el-radio label="2">区间值（首重)</el-radio>
                        <el-radio label="3">单价</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="addFrom.type == 1" style="display: flex;align-items: center;justify-content: flex-start;">
                    <el-form-item label="固定值：">
                        <el-input v-model="addFrom.firstPrice" size="small" style="width: 100px"
                            type="number" @blur="(e) => validateMinValue(e, addFrom, 'firstPrice')"></el-input> 元
                    </el-form-item>
                    <el-form-item label="实际：" class="actual-price-label">
                        <el-input v-model="addFrom.actualFirstPrice" size="small" style="width: 100px"
                            type="number" @blur="(e) => validateMinValue(e, addFrom, 'actualFirstPrice')"></el-input>
                        元
                    </el-form-item>
                </div>
                <div v-if="addFrom.type == 2">
                    <el-form-item>
                        首重：<el-input type="number" v-model='addFrom.firstWeight' style='width:60px' @blur="(e) => validateMinValue(e, addFrom, 'firstWeight')" /> kg &nbsp;&nbsp;
                        首重价格：<el-input type="number" v-model='addFrom.firstPrice' style='width:60px' @blur="(e) => validateMinValue(e, addFrom, 'firstPrice')" /> 元 &nbsp;&nbsp;
                        超过的单价：<el-input type="number" v-model='addFrom.excessPrice' style='width:60px' @blur="(e) => validateMinValue(e, addFrom, 'excessPrice')" /> 元/
                        <el-input type="number" v-model='addFrom.excessWeight' style='width:60px'
                            @blur="kgblur(addFrom.excessWeight, 2)" /> kg
                    </el-form-item>
                    <el-form-item>
                        <div
                            style="display: inline-block;width: 132px;text-align: right;font-weight: 700;color: black;">
                            实际:
                        </div>
                        首重价格：<el-input type="number" v-model='addFrom.actualFirstPrice' style='width:60px' @blur="(e) => validateMinValue(e, addFrom, 'actualFirstPrice')" /> 元
                        &nbsp;&nbsp;
                        超过的单价：<el-input type="number" v-model='addFrom.actualExcessPrice' style='width:60px' @blur="(e) => validateMinValue(e, addFrom, 'actualExcessPrice')" /> 元/
                        <el-input disabled type="number" v-model='addFrom.excessWeight' style='width:60px' /> kg
                    </el-form-item>
                </div>
                <div v-if="addFrom.type == 3" style="display: flex;align-items: center;justify-content: flex-start;">
                    <el-form-item label="单价：">
                        <el-input v-model="addFrom.firstPrice" size="small" style="width: 100px"
                            type="number" @blur="(e) => validateMinValue(e, addFrom, 'firstPrice')"></el-input> 元
                    </el-form-item>
                    <el-form-item label="实际：" class="actual-price-label">
                        <el-input v-model="addFrom.actualFirstPrice" size="small" style="width: 100px"
                            type="number" @blur="(e) => validateMinValue(e, addFrom, 'actualFirstPrice')"></el-input>
                        元
                    </el-form-item>
                </div>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button class="form-btn btn-gray" @click="closeAdd">取 消</el-button>
                <el-button class="form-btn btn-blue" @click="confirmAddCheck">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增时价格弹框提示 -->
        <el-dialog title="提示" :visible.sync="addTips" width="20%" @close="addTipsClose">
            <p>结束重量不能小于{{ addFrom.startWeight }}</p>
            <!-- <el-button type="primary" @click="confirmEdit">确 定</el-button> -->
        </el-dialog>

        <!-- 新增时不为空弹框提示 -->
        <el-dialog title="提示" :visible.sync="editTips" width="20%" @close="editTipsClose">
            <p>重量或者价格不能为空，请填写后在提交</p>
            <!-- <el-button type="primary" @click="confirmEdit">确 定</el-button> -->
        </el-dialog>

        <!-- 提交保存时弹框提示 -->
        <el-dialog title="提示" :visible.sync="SubmitSaveTips" width="20%" @close="SubmitSaveTipsClose">
            <p>重量大小配置顺序有误，请检查！</p>
            <!-- <el-button type="primary" @click="confirmEdit">确 定</el-button> -->
        </el-dialog>

    </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
export default {
    name: 'billing_ple',
    components: { tableCon },
    data() {
        // var compare = (rule, value, cb) => {
        //   return cb();
        // };
        return {
            rules: {
                endWeight: [
                    { required: true, message: "请输入重量", trigger: "blur" },
                    // { validator: compare, trigger: "blur" }
                ],


            },
            logisticsCompanyId: "",
            queryInfo: {
                userName: "",
                userId: "",
                pageSize: 15,
                pageNum: 1,
            },
            configWeight: {//重量接收
                id: 0,
                startWeight: 0,
                endWeight: 0,
                type: "",
                firstWeight: 0,
                firstPrice: 0,
                excessWeight: 0,
                excessPrice: 0,
                sortFlag: "",
            },
            editFrom: {
                type: '2',
                startWeight: '',
                endWeight: '',
                firstWeight: '',
                firstPrice: '',
                excessWeight: '',
                excessPrice: '',
                subscript: ''//下标
            },
            //增加的
            addFrom: {
                type: '2',
                startWeight: '',
                endWeight: '',
                firstWeight: '',
                firstPrice: '',
                excessWeight: '',
                excessPrice: '',
                subscript: ''//下标
            },
            configList: [],
            // total: 0,
            dialogVisible: false,
            dialogVisibleAdd: false,
            addTips: false,
            editTips: false,
            SubmitSaveTips: false,
            numTips: 0,
        };
    },
    methods: {
        validateMinValue(event, row, field) {
            const val = event.target.value;
            if (Number(val) < 0) {
                this.$message.warning('输入值不能小于0');
                row[field] = null;
            }else{                
                if(this.dialogVisible == false && this.dialogVisibleAdd == false){
                    this.SubmitSave();
                }
            }
        },
        confirmAdd() {
            let index = this.configList.length;
            if (index > 1) {
                let lastData = this.configList[index - 1];
                this.configList.splice(index - 1, 1)
                this.configList.push(this.addFrom);
                this.configList.push(lastData);
                this.configList[this.configList.length - 1].startWeight = this.addFrom.endWeight;
            } else if (index == 0) {
                this.addFrom.sortFlag = 99;
                this.configList.unshift(this.addFrom);
            } else {
                this.configList[0].startWeight = this.addFrom.endWeight;
                this.configList.unshift(this.addFrom);
            }
            this.SubmitSave();
            this.dialogVisibleAdd = false;
        },
        //新增时 为空校验
        confirmAddCheck() {
            //校验重量区间
            if (!this.validateWeightRange()) {
                return;
            }

            //校验必填字段
            if (!this.validateRequiredFields()) {
                this.editTips = true;
                return;
            }

            //校验区间数量限制
            if (this.configList.length >= 15) {
                this.$message.error('最多可添加15个重量区间，请重新操作！');
                return;
            }

            //通过校验，提交数据
            this.confirmAdd();
        },

        // 校验重量区间
        validateWeightRange() {
            if (new Number(this.addFrom.startWeight) >= new Number(this.addFrom.endWeight)) {
                this.addTips = true;
                this.addFrom.endWeight = null;
                return false;
            }

            if (this.configList.length && !this.addFrom.endWeight) {
                return false;
            }

            return true;
        },

        // 校验必填字段
        validateRequiredFields() {
            const { type, firstPrice, firstWeight, excessPrice, excessWeight } = this.addFrom;

            // 固定总值或单价模式
            if (type === '1' || type === '3') {
                return firstPrice && firstPrice.length > 0;
            }

            // 区间值模式
            if (type === '2') {
                return firstWeight && firstWeight.length > 0
                    && firstPrice && firstPrice.length > 0
                    && excessPrice && excessPrice.length > 0
                    && excessWeight && excessWeight.length > 0;
            }

            return false;
        },

        closeAdd() {
            this.dialogVisibleAdd = false;
        },
        ConfigAddClose() {
            this.dialogVisibleAdd = false;
        },
        addConfig() {
            if (this.configList.length > 1) {
                this.addFrom.startWeight = this.configList[this.configList.length - 2].endWeight;
            }
            if (this.configList.length == 1) {
                this.addFrom.startWeight = this.configList[this.configList.length - 1].endWeight;
            }
            this.dialogVisibleAdd = true;

        },
        addTipsClose() {
            this.addTips = false;
        },
        editTipsClose() {
            this.editTips = false;
        },
        SubmitSaveTipsClose() {
            this.SubmitSaveTips = false;
        },
        //新增校验
        blur(val) {
            if (new Number(this.addFrom.startWeight) >= new Number(this.addFrom.endWeight)) {
                this.addTips = true
                this.addFrom.endWeight = null;
            }
        },
        // 重量校验
        kgblur(val, key) {
            if (key != 0) {
                if (val <= 0) {
                    this.$message.error('请输入大于0的重量');
                    if (key == 1) {
                        this.editFrom.excessWeight = null;
                    }
                    if (key == 2) {
                        this.addFrom.excessWeight = null;
                    }
                }
            } else {
                if (val.excessWeight <= 0) {
                    this.$message.error('请输入大于0的重量');
                    this.configList.forEach(item => {
                        if (item.id == val.id) {
                            item.excessWeight = null;
                        }
                    });
                }
            }
        },
        //编辑校验
        editCheck(val) {
            if (this.configList.indexOf(val) + 2 != this.configList.length) {
                if (val.endWeight > this.configList[this.configList.indexOf(val) + 1].endWeight) {
                    this.numTips = this.configList[this.configList.indexOf(val) + 1].endWeight;
                    this.editTips = true;
                    this.configList[this.configList.indexOf(val)].endWeight = null;
                    this.monitor(val)
                }
            }
        },
        //输入时 监控
        monitor(val) {
            var index = this.configList.indexOf(val);
            this.configList[index + 1].startWeight = val.endWeight
        },
        //编辑配置
        editConfig(row) {
            this.dialogVisible = true
            this.editFrom = JSON.parse(JSON.stringify(row));
            this.editFrom.subscript = this.configList.indexOf(row)
        },
        //保存编辑配置
        confirmEdit() {
            this.$set(this.configList, this.editFrom.subscript, this.editFrom);
            this.dialogVisible = false;
        },
        //删除选中的
        delConfig(row) {
            this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    //删除的下标
                    let num = this.configList.indexOf(row);
                    this.configList[num + 1].startWeight = this.configList[num - 1].endWeight;
                    this.configList[num].delFlag = 1;
                    console.log(this.configList)
                    this.SubmitSave();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
        },

        async SubmitSave() {
            let check = false;
            this.configList.forEach(item => {
                if (item.startWeight >= item.endWeight) {
                    if (item.sortFlag != 99) {
                        console.log(item, '====')
                        check = true;
                        return;
                    }
                }
            })
            if (check) {
                this.SubmitSaveTips = true;
            } else {
                const { data: res } = await this.$http.post("InternationalShippingConfig/editInternationalShippingConfig",
                    {
                        "listJson": JSON.stringify(this.configList),
                        logisticsCompanyId: this.logisticsCompanyId
                    }
                );

                if (res.code == 2500) {
                    this.$message.error(res.message);
                }
                this.getconfigList()

            }

        },
        goto() {
            this.$router.push('/LogisticsCompany')
        },
        //失去焦点
        onInputBlur(rule, value, callback) {
            if (value == null) {
                thisStyle(new Error('请输入重量'));
            } else if (value != '') {
                thisStyle(new Error('该用户名已经存在，请重新输入'));
            } else {
                callback();
            }

        },
        async getconfigList() {
            const params = {
                logisticsCompanyId: this.logisticsCompanyId
            }
            const { data: res } = await this.$http.get("InternationalShippingConfig/getCompanyInternationalShippingConfig", { params });
            console.log(res);
            this.configList = res.data;
        },

        closeAccessoriesDialog() {
            this.dialogVisible = false;
            this.init();
        },
        ConfigDialogClose() {
            this.dialogVisible = false;
            this.init();
        },
        init() {
            this.editFrom = {
                type: '2',
                startWeight: '',
                endWeight: '',
                firstWeight: '',
                firstPrice: '',
                excessWeight: '',
                excessPrice: ''
            }
        }
    },

    created() {
        this.logisticsCompanyId = this.$route.query.id;
        this.getconfigList();
    },
};
</script>

<style lang="less" scoped>
.role-page>.search-container {
    height: 60px !important;
}

.el-table .el-button--small {
    padding: 4px 10px;
}

.actual-price-label {
    /deep/ .el-form-item__label {
        font-weight: 700;
        color: black;
    }
}
</style>